<template>
	<div class="popup popup--mini" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">Уверены, что желаете удалить комментарий?</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__content">
				<div class="popup__btns">
					<button class="btn btn--color" @click.prevent="sendForm">Да</button>
					<button class="btn btn--border" @click="$emit('close')">Нет</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Fetch from "@/utils/Fetch";
import {mapActions} from "vuex";
import {useToast} from "vue-toastification";
import objectToFormData from "@/utils/ObjectToFormData";


export default {
	name: 'ApproveRemoveTenderComment',
	props: {
		positionId: {
			type: Number,
			default: () => null
		}
	},
	data() {
		return {
			toast: useToast(),
			formData: {
				position: this.positionId
			}
		}
	},
	methods: {
		async sendForm() {
			const body = objectToFormData({
				position: this.formData.position,
			})

			let response = await Fetch(`/tenders/positions/clear-comment/`, {
				method: 'POST',
				body
			})

			if(response.success) {
				this.toast.success(`Комментарий успешно удален`);
				this.$emit('close')
				this.$emit('clearComment')
			} else {
				this.toast.error(response.message);
				this.$emit('close')
			}
		},
		...mapActions({
            requestTenderItem: 'tenders/requestTenderItem',
		}),
	},

}
</script>
